module.exports = __webpack_public_path__ + "img/mt5-icon4.c9aaa27.png";